import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services';
import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
import { ToasterService } from 'src/app/services';
Quill.register('modules/blotFormatter', BlotFormatter);
@Component({
  selector: 'app-feedback-popup',
  templateUrl: './feedback-popup.component.html',
  styleUrls: ['./feedback-popup.component.scss']
})
export class FeedbackPopupComponent {

  @Input() pageName: string = '';

  @ViewChild('feedbackForm') feedbackForm: NgForm;
  subject: Subject<any>;

  feedbackText: string = '';
  feedbackContact: boolean = false;

  quillModules = {
    blotFormatter: {},
    // toolbar: [
    //   ['bold', 'italic', 'underline', 'strike'],
    //   [{ 'align': [] }],
    //   ['link', 'image'],
    //   ['clean'],
    // ]
  };

  constructor(public reportService: ReportService,
    private toastr: ToasterService,
    public bsModalRef: BsModalRef) { }

  autoGrow(event) {
    event.target.style.height = 'auto';
    event.target.style.height = event.target.scrollHeight + "px";
    if (event.target.value == '') {
      event.target.style.height = '24px';
    }
  }

  /**
   * @description on submit click
   */
  submit() {
    const param = {
      success: true,
      feedbackText: this.feedbackText,
      feedbackContact: this.feedbackContact
    }
    this.bsModalRef.hide();
    this.subject.next(param);
    this.subject.complete();
  }

  /** Cancel click */
  cancel() {
    this.bsModalRef.hide();
    this.subject.next({ success: false });
    this.subject.complete();
  }

}
